import { Layout } from "antd";
import React from "react";
import DashLayout from "../../../../Components/Admin/AdminDashLayout";
import Attendance from "./Attendance";

const MainSection = () => {
  return (
    <Layout title={"Staff Attendance | Office Flow"}>
      <DashLayout children={<Attendance />} />
    </Layout>
  );
};

export default MainSection;
